import { render, staticRenderFns } from "./specialized-new-zone-advertise.vue?vue&type=template&id=a5923038&scoped=true"
import script from "./specialized-new-zone-advertise.vue?vue&type=script&lang=js"
export * from "./specialized-new-zone-advertise.vue?vue&type=script&lang=js"
import style0 from "./specialized-new-zone-advertise.vue?vue&type=style&index=0&id=a5923038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5923038",
  null
  
)

export default component.exports